export default "__VITE_ASSET__07549ecf__"